import { request } from '../client';

// Which outlets serve a delivery location, as the backend resolves it. The
// geography travels in the X-Delivery-* headers (the global browsing value,
// or `deliveryGeography` to pin one); the response names outlets for display
// only and is never sent back.
export const getServiceContext = (deliveryGeography) =>
  request('/service-context', deliveryGeography === undefined ? {} : { deliveryGeography });

// Can this location be served? The backend reads it from the query alone and
// requires a pincode; lat/lng are optional but must be sent together. No
// geography headers are attached, so the answer is about exactly these values.
export const checkServiceability = ({ pincode, lat, lng } = {}) =>
  request('/serviceability', { params: { pincode, lat, lng }, deliveryGeography: null });
